import React, { memo, useEffect, useState } from "react";
import "assets/css/new-result.css";
import SpeakingResult from "components/Result/SpeakingResult";
import WritingResult from "components/Result/WritingResult";
import ReadingResult from "components/Result/ReadingResult";
import ListeningResult from "components/Result/ListeningResult";
import ShowHistoryData from "../../../views/ShowHistoryData.jsx";
import ReactHtmlParser from "react-html-parser";
import MoreAiSuggestions from "components/Result/More/MoreAiSuggestions";
import WriteFromDictationResult from "components/Result/WriteFromDictationResult";

const Result = memo(function Result({
  isAnswer,
  resultData,
  speakingResult,
  writingResult,
  readingResult,
  listeningResult,
  newResult,
  newHtml,
  subcategoryId,
  correctAnswer,
  historyData,
  question_id,
  isPopup,
  recorded_file,
  writeFromDictationResult,
  question,
  renderResponse,
  script,
  html,
  showExplanation = () => {},
  speed_percentage=null
}) {
  const [showMainContent, setShowMainContent] = useState(true);
 
  const renderResponseHtml = (html) => {
    return renderResponse(html);
  };

  const renderResponseHtmlOldStyle = (html) => {
    return ReactHtmlParser(newResult.html);
  };

  useEffect(() => {
    console.log("Qustion data : ",script)
  })

  const fetchAiSuggestions = () => {
    let html = "";

    if (subcategoryId === 7) {
      html = (
        <div className="more-options d-flex align-items-center px-0">
          <div className="result-score">Suggestions:</div>

          <MoreAiSuggestions question_id={question_id} 
          hideParent={() => setShowMainContent(false)}
          showParent={() => setShowMainContent(true)}
          />
        </div>
      );
    }

    return html;
  };

  return (
    <>
      {isAnswer && resultData !== "" && (
        <>
          <div
            className={`result-popup-content p-0 ${!isPopup ? "result-without-popup" : ""
              }`}
          >
            {speakingResult && (
              <SpeakingResult
                resultData={newResult}
                recorded_file={recorded_file}
                newHtml={newHtml}
                newResult={newResult}
                renderResponseHtml={renderResponseHtml}
                renderResponseHtmlOldStyle={renderResponseHtmlOldStyle}
                subcategoryId={subcategoryId}
                correctAnswer={correctAnswer}
                html={html}
                showMainContent={showMainContent}
                speed_percentage={speed_percentage}
                moreDetails={
                  <ShowHistoryData
                    showBackButton={true}
                    data={historyData}
                    flag={1}
                    id={false}
                    openAiRemarks={newResult}
                    type={subcategoryId}
                    question={question}
                    showExplanation={showExplanation}
                    hideParent={() => setShowMainContent(false)}
                    showParent={() => setShowMainContent(true)}
                    speed_percentage={speed_percentage}
                  />
                }
              />
            )}

            {writingResult && (
              <WritingResult
                resultData={newResult}
                buttonsOnly={false}
                essay={subcategoryId === 7 ? true : false}
                newHtml={newHtml}
                newResult={newResult}
                renderResponseHtml={renderResponseHtml}
                renderResponseHtmlOldStyle={renderResponseHtmlOldStyle}
                subcategoryId={subcategoryId}
                showMainContent={showMainContent}
                moreDetails={
                  <ShowHistoryData
                    showBackButton={true}
                    data={historyData}
                    flag={1}
                    id={false}
                    openAiRemarks={newResult}
                    type={subcategoryId}
                    question={question}
                    showExplanation={showExplanation}
                    hideParent={() => setShowMainContent(false)}
                    showParent={() => setShowMainContent(true)}
                  />
                }
                aiSuggestions={fetchAiSuggestions()}
              />
            )}

            {readingResult && (
              <ReadingResult
                resultData={newResult}
                subcategoryId={subcategoryId}
                moreDetails={
                  <ShowHistoryData
                    showBackButton={false}
                    data={historyData}
                    flag={1}
                    id={false}
                    openAiRemarks={newResult}
                    type={subcategoryId}
                    question={question}
                    showExplanation={showExplanation}
                    hideParent={() => setShowMainContent(false)}
                    showParent={() => setShowMainContent(true)}
                  />
                }
              />
            )}

            {listeningResult && (
              <ListeningResult
                resultData={newResult}
                subcategoryId={subcategoryId}
                showMainContent={showMainContent}
                moreDetails={
                  <ShowHistoryData
                    showBackButton={true}
                    data={historyData}
                    flag={1}
                    id={false}
                    openAiRemarks={newResult}
                    type={subcategoryId}
                    question={question}
                    showExplanation={showExplanation}
                    hideParent={() => setShowMainContent(false)}
                    showParent={() => setShowMainContent(true)}
                  />
                }
              />
            )}

            {writeFromDictationResult && (
              <WriteFromDictationResult
                resultData={newResult}
                newHtml={newHtml}
                newResult={newResult}
                renderResponseHtml={renderResponseHtml}
                renderResponseHtmlOldStyle={renderResponseHtmlOldStyle}
                subcategoryId={subcategoryId}
                showMainContent={showMainContent}
                moreDetails={
                  <ShowHistoryData
                    showBackButton={true}
                    data={historyData}
                    flag={1}
                    id={false}
                    openAiRemarks={newResult}
                    type={subcategoryId}
                    question={question}
                    showExplanation={showExplanation}
                    hideParent={() => setShowMainContent(false)}
                    showParent={() => setShowMainContent(true)}
                  />
                }
                script={script}
                questionAudios={question?.question_audios}
                mediaLink={question?.media_link}
              />
            )}
          </div>
        </>
      )}
    </>
  );
});
export default Result;
